import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { URL } from '../../handlers/common/commonapi';
import BackButton from "../../assets/images/backBtn.svg";
import NearMeIcon from "@mui/icons-material/NearMe";
import CartIcon from "../../component/common/Carticon";
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import LogInPopup from '../../screens/AuthScreen/LogInPopup'; // Import the LoginPopup component

const Unauthorized = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false); // State for controlling popup visibility
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    setIsLoading(true);
    if (token) {
      navigate('/', { replace: true });
      return;
    } else {
      setIsLoading(false);
    }
  }, [navigate, token]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("cartItems");
    navigate("/");
  };

  const handleLogin = () => {
    setShowLoginPopup(true); // Show the login popup instead of navigating
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleCartClick = () => {
    navigate("/viewcart");
  };

  const handlePopupClose = () => {
    setShowLoginPopup(false);
  };

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
        <div className="max-w-md p-8 bg-white rounded-lg shadow-md text-center">
          <div className="flex justify-center items-center space-x-4">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
            <span className="text-gray-600">Checking authentication status...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <header>
        <div className="flex flex-row justify-between mt-4 mx-4">
          {/* <button
            onClick={handleBack}
            className="backBtn flex items-center space-x-2"
          >
            <img
              className="rounded-full nav-profile-pic"
              src={BackButton}
              alt="Back Button"
            />
            <span>Back</span>
          </button> */}
          <div className="flex items-center space-x-4">
            {/* <button
              onClick={handleCartClick}
              className="flex rounded-full"
            >
              <CartIcon className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12" />
            </button> */}
            {token ? (
              <div 
                className="flex items-center space-x-2 cursor-pointer"
                onClick={handleLogout}
              >
                <LogoutIcon className="w-6 h-6 text-gray-800" />
                <span className="text-gray-800 font-semibold">Logout</span>
              </div>
            ) : (
              <div 
                className="flex items-center space-x-2 cursor-pointer"
                onClick={handleLogin}
              >
                <LoginIcon className="w-6 h-6 text-gray-800" />
                <span className="text-gray-800 font-semibold">Login</span>
              </div>
            )}
          </div>
        </div>
        {/* <div className="flex max-w-full justify-between px-6 lg:px-20 items-center header-section">
          <h1 className="relative py-6 venueDetailsHeading">
            Unauthorized Access
            <br />
            <h6 className="relative text-sm">
              You don't have permission to view this page
            </h6>
          </h1>
        </div> */}
      </header>

      {/* Login Popup - will appear when showLoginPopup is true */}
      {showLoginPopup && <LogInPopup togglePopup={handlePopupClose} />}

      <div className="flex flex-col items-center justify-center bg-gray-50 mt-8">
        <div className="max-w-md p-8 bg-white rounded-lg shadow-md text-center">
          <h1 className="text-3xl font-bold text-red-500 mb-4">401 Unauthorized</h1>
          <p className="text-gray-600 mb-6">
            You don't have permission to access this page. Please log in to continue.
          </p>
          <button
            onClick={handleLogin}
            className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
          >
            Click to Login
          </button>
        </div>
      </div>
    </>
  );
};

export default Unauthorized;